import { Component, Inject, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'dg-emp-search-lib';
import { ActionDialogData } from '../dg-actions/models/action-dialog-data.model';
import { post } from 'jquery';
@Component({
  selector: 'app-dg-page-delete',
  templateUrl: './dg-page-delete.component.html',
  styleUrls: ['./dg-page-delete.component.scss'],
})
export class DgPageDeleteComponent implements OnInit {
  status: string;
  applTypeId: '';
  caseData: any;
  selectedCorr: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    @Inject(MAT_DIALOG_DATA) public dialogData: ActionDialogData,
    // @Inject(MAT_DIALOG_DATA) public appTypeId: any,

    private dialogRef: MatDialogRef<DgPageDeleteComponent>
  ) {}

  ngOnInit(): void {}

  onSend(): void {
    this.caseData = this.data;
    this.selectedCorr = this.caseData?.data;
    let postData = {
      arrJobMvmntPk: [],
      arrOutboxPk: [],
      applTypeId: '',
    };

    if (this.selectedCorr) {
      postData.applTypeId = this.selectedCorr[0].appTypeId;
      for (const s of this.selectedCorr) {
        postData.arrJobMvmntPk.push(Number(s.jobMvmntPk));
        postData.arrOutboxPk.push(Number(s.jobMvmntPk));
      }
    } else {
      postData.applTypeId = this.caseData[0].appTypeId;
      for (const s of this.caseData) {
        postData.arrJobMvmntPk.push(Number(s.jobMvmntPk));
        postData.arrOutboxPk.push(Number(s.jobMvmntPk));
      }
    }

    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: postData,
    };

    this.http.delete('/case-mgmnt/sent-case', options).subscribe((s) => {
      this.dialogRef.close(true);
    });
  }
}
